<template>
    <ModalWindow :open="openWindowModal"
                 :is-large="true"
                 :full-window="true"
                 @closeModal="openWindowModal = false">
        <template slot="title">Search ARTIcles</template>
        <template slot="body">
            <TableFilter
                @resetFilter="resetFilter"
                @applyFilter="applyFilter"
                :filter="filter"
                :filter-open="filterOpen"/>

            <Table :page="page" :last_page="last_page" @setPage="setPage" type="modal">
                <template slot="thead">
                    <Thead :header="tableHeader" :is-counter="tableHeaderChange" @sortBy="sortBy" />
                </template>
                <template slot="tbody">
                    <tr v-for="item in listItems" :key="item.id">
                        <td class="link" @click="selectElement(item)">Select item</td>
<!--                        <td class="link">
                            <router-link class="link" target="_blank" :to="{name: 'artifact.edit', params: {id: item.id}}">
                                Open in new tab
                            </router-link>
                        </td>-->
                        <td class="text-left wrap">{{ item.title }}</td>
                        <td class="text-left wrap" v-html="getCategory(item)"></td>
                        <td class="text-left">{{ getIsPressValue(item.is_press) }}</td>
                        <td class="text-left">{{ item.visible ? 'Yes' : '-' }}</td>
                    </tr>
                </template>
            </Table>
        </template>
        <template slot="buttons">

        </template>
    </ModalWindow>
</template>

<script>
import ModalWindow from "./ModalWindow";
import TableList from "../Utils/Table/TableList";

export default {
    name: "ModalSearchCustomer",

    mixins: [TableList],

    components: {
        ModalWindow,
    },

    props: {
        isOpenModal: {
            type: Boolean,
        }
    },

    watch: {
        isOpenModal(val) {
            this.openWindowModal = val
        },
        openWindowModal(val) {
          if (val === false) {
              this.$emit('closeModal')
          }
      }
    },

    data() {
        return {
            openWindowModal: false,

            lang: this.$ml.get('pages.blog_post'),

            defaultOption: [],

            filter: {
                categories: { value: null, type: 'select', options: [] },
                title: { value: null, type: 'text'},
                is_press: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                }
            },
            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'title', is_sort: true, classes: 'text-l wrap' },
                { key: 'categories', is_sort: true, classes: 'text-l wrap' },
                { key: 'is_press', is_sort: true, classes: 'text-l' },
                { key: 'visible', is_sort: true, classes: 'text-l' },
            ],


            apiList: this.$store.getters.getApiUrl('blog_post'),
            pageRoute: 'blog_post',
            pageRouteCreate: 'blog_post.create',
            pageRouteEdit: 'blog_post.edit',
        }
    },

    created() {
        for (let key in this.filter) {
            this.filter[key].label = this.lang.filter.labels[key]
        }

        this.tableHeader.map(item => {
            item.label = this.lang.table.labels[item.key]
            return item
        })
    },

    mounted() {
        this.getData()
    },

    methods: {
        appendFilter(filter) {
            //filter.is_press = false
            return filter
        },
        getCategory(item) {
            if (item.categories.length > 0) {
                let names = []
                item.categories.map(category => {
                    names.push(category.title)
                })
                return names.join(', ');
            }
        },
        setPage(page) {
            this.page = page
            this.getData()
        },
        selectElement(item) {
            this.$emit('selected', item)
        },
        getImage(item) {
            let image = item.preview_url_cdn_query
            if (!item.preview_url_cdn_query) {
                image = '/images/no_image.png'
            }
            if (!item.is_published) {
                image = '/images/no_image.png'
            }
            return '<img class="image-cover" style="background-image: url('+image+')">'
        },
        getIsPressValue(value) {
            switch (value) {
                case true: return 'Yes'
                case false: return 'Not'
                default: return '-'
            }
        }
    }
}
</script>

<style scoped>

</style>
